import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const BarraProgressoCircular = ({ percentage, color, styleWidth }) => {

  const porcentagemFormatada = percentage != null ?`${parseFloat(percentage).toFixed(2).replace('.', ',')}%` : '-';

  
  return (
    <div style={{ width: styleWidth, margin: '0 auto'}} >
      <CircularProgressbar
        value={percentage !=null ? percentage : 0}
        text={porcentagemFormatada}
        styles={{
          root: { width: '100%' },
          path: { stroke: color },
          trail: { stroke: '#e8d5d5' },
          text: { fill: '#080808', fontSize: '18px', fontWeight: 'bold' },
        }}
      />
    </div>
  );
};

export default BarraProgressoCircular;
